import React from 'react';

const NewsDevelopments = () => {
  return (
    <>
      {/* Collaboration Section */}
      <div className="bg-white p-5 mb-6 border rounded-lg w-full sm:w-[90%] md:w-[80%] lg:w-[128%] mx-auto">
        <h2 className="text-2xl font-semibold mb-3">Collaboration</h2>
        <p className="text-gray-600 text-lg">
          In March 2022, AstraZeneca collaborated with UK-based Huma. Under this collaboration, AstraZeneca sold its AMAZETM disease management platform to Huma. Further, both companies would jointly scale up digital health solutions offerings. This collaboration would help the company in strengthening its telecare offerings.
        </p>
      </div>

      {/* Partnership Section */}
      <div className="bg-white p-5 mb-6 border rounded-lg w-full sm:w-[90%] md:w-[80%] lg:w-[128%] mx-auto">
        <h2 className="text-2xl font-semibold mb-3">Partnership</h2>
        <p className="text-gray-600 text-lg">
          In March 2020, AstraZeneca entered in a partnership with BrightInsight, and MedTech. Under this partnership, both the companies would develop digital health products and services for AstraZeneca. This partnership would help AstraZeneca in strengthening its telecare offerings.
        </p>
      </div>
    </>
  );
};

export default NewsDevelopments;
